import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ServerUrlService } from 'src/app/services/server-url.service'; 

@Injectable({
  providedIn: 'root'
})
export class AgendamentosService {

  constructor(
    private http: HttpClient,
    private serverUrlService: ServerUrlService
    ) { }

  buscaTodosAgendamentos(token) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json',
        token
      }),
      observe: 'response' as 'body'
    };

    return this.http.get(`${this.serverUrlService.getUrl()}/agendamentos`, httpOptions);
  }

  buscaMeusAgendamentos(id, token) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json',
        token
      }),
      observe: 'response' as 'body'
    };

    const body = { usuario_id: id };

    return this.http.post(`${this.serverUrlService.getUrl()}/agendamentos/usuario`, body, httpOptions);
  }

  buscaAgendamento(id, token) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json',
        token
      }),
      observe: 'response' as 'body'
    };
    return this.http.get(`${this.serverUrlService.getUrl()}/agendamento/${id}`, httpOptions);
  }

  buscaAgendamentoOtimus(agendamentoId: number, token: string) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json',
        token
      }),
      observe: 'response' as 'body'
    };
    return this.http.get(`${this.serverUrlService.getUrl()}/agendamento/otimus/${agendamentoId}`, httpOptions);
  }

  buscaPacienteSemToken(usuarioId: number) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json',
      }),
      observe: 'response' as 'body'
    };
    return this.http.get(`${this.serverUrlService.getUrl()}/usuarios/${usuarioId}`, httpOptions);
  }

  buscaPaciente(usuarioId: number, token: string) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json',
        token
      }),
      observe: 'response' as 'body'
    };
    return this.http.get(`${this.serverUrlService.getUrl()}/usuario/${usuarioId}`, httpOptions);
  }

  buscaPacienteOtimus(usuario: any, token: string) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json',
        token
      }),
      observe: 'response' as 'body'
    };

    const body = usuario;
    return this.http.post(`${this.serverUrlService.getUrl()}/usuarios/pacientesotimus`, body, httpOptions);
  }

  buscaPacienteOtimusSemToken(usuario: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json',
      }),
      observe: 'response' as 'body'
    };

    const body = usuario;
    return this.http.post(`${this.serverUrlService.getUrl()}/usuarios/pacientesotimus`, body, httpOptions);
  }

  vincularPacienteOtimus(id: number, integracaoId: number, token: string) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json',
        token
      }),
      observe: 'response' as 'body'
    };

    const body = {
      id,
      integracao_id: integracaoId
    };
    return this.http.post(`${this.serverUrlService.getUrl()}/usuario/vincular`, body, httpOptions);
  }

  vincularPacienteOtimusSemToken(id: number, integracaoId: number) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json',
      }),
      observe: 'response' as 'body'
    };

    const body = {
      id,
      integracao_id: integracaoId
    };
    return this.http.post(`${this.serverUrlService.getUrl()}/usuarios/vincular`, body, httpOptions);
  }

  criarPacienteOtimus(body: any, token: string) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json',
        token
      }),
      observe: 'response' as 'body'
    };

    return this.http.post(`${this.serverUrlService.getUrl()}/usuario/otimus/novo`, body, httpOptions);
  }

  criarPacienteOtimusSemToken(body: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json',
      }),
      observe: 'response' as 'body'
    };

    return this.http.post(`${this.serverUrlService.getUrl()}/usuarios/otimus/novo`, body, httpOptions);
  }

  mudarStatusAgendamento(agendamentoid: number, status: string, token: string) {
    return this.http.get(
      `${this.serverUrlService.getUrl()}/agendamento/change-status/${agendamentoid}/${status}`,
      {
        headers: new HttpHeaders({
          token
        })
      }
    )
  }

  desmarcarAgendamento(agendamentoid: number | string, agendatipo: 'exames' | 'consulta') {
    return this.http.delete(`${this.serverUrlService.getUrl()}/agendamento-desmarcar/${agendamentoid}/${agendatipo === 'exames' ? 'cs' : 'ag'}`)
  }

  buscarAgendamentoPorIntegracaoId(agendaTipo: string, integracaoId: number) {
    return this.http.get(`${this.serverUrlService.getUrl()}/agendaments/${agendaTipo}/integracaoId/${integracaoId}`)
  }
}
